import { Brand } from "../../types"
import { normalizeUrl } from "./string"

export const mapBrandToDraft = (data: Brand): Brand => ({
  ...data,
  place_id: data?.place_id || data?.google_place_id || "",
  website: data.website ?? ""
})

export const mapDraftToBrand = (data: Brand): Brand => ({
  ...data,
  website: normalizeUrl(data.website)
})

export const convertBoolToEnabled = (bool: boolean) =>
  bool ? "Enabled" : "Disabled"

export const convertBoolToYesNo = (bool: boolean) => (bool ? "Yes" : "No")

export const getBrandExportLOsURL = (brandId: string) =>
  `${process.env.REACT_APP_API_HOST}/lo-export.csv?brand_id=${brandId}`
